import { StyledHeader, StyledPaper } from './styles';
import Typography from '@mui/material/Typography';
import i18n from '../../i18';
import React, { useEffect } from 'react';
import Popper from '@mui/material/Popper';
import Grow from '@mui/material/Grow';

export const SearchSelectWrapper = ({
    buttonRef,
    open,
    items,
    title,
    children,
    clearData,
    onClose,
    totalCount
}) => {
    const popperRef = React.useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                popperRef.current &&
                !popperRef.current.contains(event.target)
            ) {
                onClose(null);
                clearData();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [popperRef, onClose, clearData]);

    const handleCloseSelect = () => {
        onClose(null);
        clearData();
    };

    return (
        <Popper
            ref={(node) => {
                popperRef.current = node;
            }}
            open={open}
            anchorEl={buttonRef.current}
            placement="bottom-start"
            style={{
                zIndex: 2000
            }}
        >
            <Grow in={open} onExit={handleCloseSelect}>
                <StyledPaper
                    style={{
                        width: buttonRef?.current?.offsetWidth || 300
                    }}
                >
                    <StyledHeader>
                        <Typography variant="subtitle2">
                            {(title || '').toLowerCase()}
                        </Typography>
                        <Typography variant="caption">
                            {totalCount || items.length}{' '}
                            {i18n.t('search.results')}
                        </Typography>
                    </StyledHeader>

                    {children}
                </StyledPaper>
            </Grow>
        </Popper>
    );
};
